import type { JobCategoryTaxonomy } from 'src/types/job-category';

export const getSubCategoryFromTaxonomy = (
  categoryList: JobCategoryTaxonomy[],
  categoryId: string,
  subCategoryId: string,
) =>
  categoryList
    .find((category) => category.seekId === categoryId)
    ?.subCategoryList?.find(
      (subCategory) => subCategory.seekId === subCategoryId,
    );
